<ng-container>

    <div *ngIf="fGroup.get('preferredDescribe').value !== true"
         class="flex flex-col w-full">

        <button
                class="m-4 gender-button"
                [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.[keyname]==='F' }"
                mat-raised-button (click)="setExt('F')"
        >
          {{'Une femme'|transloco}}
        </button>
        <button
                class="m-4 gender-button"
                [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.[keyname]==='M' }"
                mat-raised-button (click)="setExt('M')"
        >
          {{'Un homme'|transloco}}
        </button>
        <button
                class="m-4 gender-button"
                [ngClass]="{'text-white	bg-green-inbe': cUser?.extProfiles?.[keyname]==='N' }"
                mat-raised-button (click)="setExt('N')"
        >
          {{'Je m\'identifie autrement'|transloco}}
        </button>

    </div>
    <div class="flex flex-col w-full mt-2">
        <mat-checkbox class="w-full" [formControl]="$any(fGroup.get('preferredDescribe'))">
            {{'Je préfère me décrire moi-même' | transloco}}
        </mat-checkbox>
        <mat-form-field
                *ngIf="fGroup.get('preferredDescribe').value === true"
                class="fuse-mat-no-subscript fuse-mat-emphasized-affix fuse-mat-rounded fuse-mat-dense w-full mt-1">
            <input
                    matInput
                    [formControl]="$any(fGroup.get('preferredDescribeText'))"
            >
        </mat-form-field>
    </div>

    <pre *ngIf="displayDebug">{{this.fGroup.getRawValue()|json}}</pre>

</ng-container>
